import { useEffect, useState } from "react";
import { useProduct, eur } from "@/lib/product";

const useHidden = () => {
  const [orderVisible, setOrderVisible] = useState(false);
  const [typing, setTyping] = useState(false);

  useEffect(() => {
    const section = document.getElementById("commander");
    const io = section && new IntersectionObserver(([e]) => setOrderVisible(e.isIntersecting), { threshold: 0 });
    if (io) io.observe(section);
    const isField = (t) => t?.matches?.("input, select, textarea");
    const onIn = (e) => isField(e.target) && setTyping(true);
    const onOut = (e) => isField(e.target) && setTyping(false);
    document.addEventListener("focusin", onIn);
    document.addEventListener("focusout", onOut);
    return () => {
      io?.disconnect();
      document.removeEventListener("focusin", onIn);
      document.removeEventListener("focusout", onOut);
    };
  }, []);

  return orderVisible || typing;
};

export const StickyBar = () => {
  const { product } = useProduct();
  const hidden = useHidden();
  if (!product || hidden) return null;
  return (
    <div data-testid="mobile-sticky-cta-bar" className="sticky-bar sm:hidden">
      <div className="flex flex-col leading-tight">
        <div className="flex items-baseline gap-2">
          <span data-testid="sticky-current-price" className="font-display text-2xl font-extrabold text-slate-900">{eur(product.current_price)}</span>
          {product.promo_active && <span data-testid="sticky-ppc" title="Prix public conseillé (PPC) : prix de vente conseillé du produit, donné à titre indicatif." className="text-xs text-slate-400">PPC <s>{eur(product.normal_price)}</s></span>}
        </div>
        <span className="text-xs text-slate-500">TTC + livraison {eur(product.shipping_fee)}</span>
      </div>
      <a href="/#commander" data-testid="sticky-cta-button" className="btn-heat !px-5 !py-3 text-sm">Commander</a>
    </div>
  );
};
